import { createSlice } from '@reduxjs/toolkit';
import {
  FETCH_INDEXING_STATUS,
  FETCH_INDEXING_STATUS_REQUEST,
  FETCH_INDEXING_STATUS_ERROR
} from "../constants/constants";

const initialState = {
  in_queue: false,
  loading: false,
  error: false,
  errMsg: '',
  lastUpdated: false
};

const indexingSlice = createSlice({
  name: 'indexing',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(FETCH_INDEXING_STATUS_REQUEST, state => {
        state.loading = true;
      })
      .addCase(FETCH_INDEXING_STATUS, (state, action) => ({
        ...state,
        ...action.data,
        loading: false,
        error: false,
        errMsg: '',
        lastUpdated: new Date().toLocaleString()
      }))
      .addCase(FETCH_INDEXING_STATUS_ERROR, (state, action) => {
        state.loading = false;
        state.error = true;
        state.errMsg = action.errMsg;
      });
  }
});

export default indexingSlice.reducer;
